import React, {useEffect, useRef} from 'react';
import {connect} from 'react-redux';
import {fetchPackageBySocCode} from '../CellcomAbroadLobbyBlock/cellcomAbroadBlockSlice';
import {showAppLoader, hideAppLoader} from '../../Shared/Loader/LoaderSlice';
import {DefaultTerms} from './DefaultTerms';
import {CombinedPackageData, DataPackageData} from './Data';
import {PackageTerms} from './PackageTerms';
import { LogoHelper, LogoType } from 'app/utilities/LogoHelper/helper';
import Image from 'app/Components/Shared/Image/image';
const BusinessAbroadTermsMain = (props) => {
  const params = new URLSearchParams(window.location.search);
  const socCode = params.get('socCode');
  const selectedPackage = props.cellcomAbroad.selectedAbroadPackage;
  const statusRequest = props.cellcomAbroad.statusRequest;
  const sectionRef = useRef([]);
  const mainLogo = LogoHelper.getLogo(LogoType.SiteLogo);

  console.log(props);
  useEffect(() => {
    props.fetchPackageBySocCode(socCode);
  }, []);
  const getPackageData = () => {
    switch (selectedPackage?.type) {
      case 'Data':
        return props.DataPackageData;
      case 'VoiceSmsData':
        return props.CombinedPackageData;
    }
  };
  const data = getPackageData();
  if (props.cellcomAbroad.termsIsLoading) {
    props.showAppLoader({isLoading: true});
  } else {
    props.hideAppLoader({isLoading: false});
  }

  const handleBackClick = (i) => {
    if (i == 'top') {
      window.scrollTo({top: 0, behavior: 'smooth'});
    }
    sectionRef.current[i].scrollIntoView({behavior: 'smooth', block: 'start', inline: 'start'});
  };
  let index = 2;
  return (
    <>
      {selectedPackage && data ? (
        <div className='businessAbroadTermsMain'>
          <div className='mainSection'>
            <div className='header'>
              <div className='cellcomLogo'>
                <Image src={mainLogo} alt='main logo' />
              </div>
              <span></span>
              <div className='cellcomDetails'>{window.Config.brand_Name_HE}  בע"מ רח' הגביש 10 ת.ד. 4060 נתניה 42140 ח.פ. 511930125</div>
            </div>
            <div className='headerTitle'>
              <h1>{selectedPackage.socDescription}</h1>
            </div>
            <div className='section'>
              <div className='mainTitle'>
                <h1>תוכן עניינים</h1>
              </div>
              <div className='titleAndDescription'>
                <a className='title' style={{cursor: 'pointer'}} onClick={() => handleBackClick(0)}>
                  {1}. עיקרי חבילת "{selectedPackage.socDescription}"
                </a>
              </div>
              {data.length
                ? data.map((section, i) => {
                    if (i === data.length - 1 && !selectedPackage.dataForApp.hasDataForApp) {
                      return null;
                    }
                    return (
                      <div className='titleAndDescription'>
                        <a className='title' style={{cursor: 'pointer'}} onClick={() => handleBackClick(i + 1)}>
                          {i + index}. {section.mainTitle}
                        </a>
                      </div>
                    );
                  })
                : null}
            </div>

            <PackageTerms selectedPackage={selectedPackage} sectionRef={sectionRef} />
            <DefaultTerms selectedPackage={selectedPackage} sectionRef={sectionRef} data={data} handleBackClick={handleBackClick} />
          </div>
        </div>
      ) : statusRequest == 'pending' ? null : statusRequest == 'rejected' ? (
        <div className='businessAbroadTermsNotFoundPage'>
          <div className='container'>
            <div className='cellcomLogo'>
              <svg width='111' height='40' viewBox='0 0 111 40' xmlns='http://www.w3.org/2000/svg'>
                <g fill='none' fill-rule='evenodd'>
                  <path
                    d='M110.869 4.732c-.16.36-.234.712-.438.956-.464.555-.944 1.116-1.503 1.572-1.616 1.32-3.277 2.586-4.914 3.882-1.328 1.051-2.67 2.092-3.803 3.36a14.518 14.518 0 0 0-1.225 1.584c-.423.63-.435 1.298-.133 2.019.71 1.69 1.586 3.294 2.481 4.889 2.475 4.407 4.871 8.857 7.077 13.405.409.844.688 1.75 1.024 2.63.034.09.053.19.061.287.04.481-.18.758-.649.667-.512-.1-1.04-.258-1.49-.515a63.194 63.194 0 0 1-3.266-2.016c-3.462-2.262-6.911-4.542-10.37-6.81-1.4-.917-2.842-1.765-4.394-2.408-1.18-.488-2.398-.757-3.686-.646-.977.085-1.88.402-2.754.822-1.57.756-2.984 1.761-4.37 2.8-2.775 2.077-5.527 4.184-8.298 6.267-.597.449-1.228.854-1.855 1.261-.246.16-.514.298-.79.396-.427.15-.718-.072-.654-.519.053-.365.164-.729.3-1.073.732-1.845 1.454-3.694 2.229-5.52 1.244-2.931 2.538-5.84 3.788-8.769.447-1.047.828-2.119 1.061-3.243.271-1.306-.094-2.34-1.21-3.07-.624-.408-1.289-.755-1.94-1.12-.464-.26-.94-.5-1.4-.762a6.444 6.444 0 0 1-.74-.487c-.743-.57-.702-1.259.148-1.643a35.666 35.666 0 0 1 2.958-1.174c1.54-.538 3.103-1.014 4.65-1.536.576-.195 1.135-.442 1.702-.668 1.458-.58 2.61-1.555 3.45-2.855.831-1.288 1.559-2.641 2.351-3.954.376-.622.758-1.247 1.213-1.81.26-.322.644-.585 1.025-.76.721-.33 1.239-.182 1.717.449.308.406.564.852.828 1.29.487.808.948 1.633 1.447 2.433a2.835 2.835 0 0 0 1.944 1.33c.538.099 1.103.181 1.641.129 1.723-.169 3.443-.377 5.157-.62 2.687-.38 5.366-.823 8.056-1.193.735-.1 1.495-.06 2.242-.034.303.01.625.111.895.253.181.095.286.335.437.524'
                    fill='var(--theme-primary, #810ea9)'
                  />
                  <path
                    d='M9.599 28.338v-5.7c0-1.31-.582-1.804-1.804-1.804H3.927v7.504h5.672zM0 17.082h7.795c4.188 0 5.73 1.425 5.73 5.73v9.307H0V17.082zM17.221 21.009H15.04v-3.927h6.137v15.037h-3.956zM24.087 36.278h3.956V23.83h-3.956v12.448zm5.759-5.148 3.316-10.122h-9.686v-3.926h14.049v1.774l-3.52 12.914h-4.13l-.03-.64zM42.384 31.508l4.072-10.5h-7.882v-7.213h3.985v3.287h8.696v1.978L46.69 32.12h-4.305zM63.444 24.644c0-2.123-.669-3.635-3.432-3.635H57.57c-.437.988-.756 2.152-.727 3.315 0 2.85 1.425 4.276 3.374 4.276 2.065 0 3.228-1.658 3.228-3.956m-10.325.524c0-1.542.407-2.967.96-4.16h-1.6v-3.926h7.33c5.467 0 7.562 2.589 7.562 7.446 0 4.653-2.85 7.824-7.242 7.824-4.334 0-7.01-2.966-7.01-7.184'
                    fill='#414045'
                  />
                </g>
              </svg>
            </div>
            <svg width='120' height='120' viewBox='0 0 120 120' xmlns='http://www.w3.org/2000/svg'>
              <defs>
                <clipPath id='rkkxw07laa'>
                  <path d='M375 0v667H0V0h375z' />
                </clipPath>
                <clipPath id='i2klka0p4b'>
                  <path d='M81 0a9 9 0 0 1 9 9v38a9 9 0 0 1-9 9H9a9 9 0 0 1-9-9V9a9 9 0 0 1 9-9h72z' />
                </clipPath>
                <clipPath id='9dgm2y500c'>
                  <path d='m22.56 0 .265.006a8.964 8.964 0 0 1 6.365 2.973l15.811 17.567H0L15.811 2.979A8.975 8.975 0 0 1 22.293.002L22.56 0zm-3.437 5.313-.172.166-.167.176-9.801 10.89H36.02l-9.803-10.89a5 5 0 0 0-.18-.19l-.191-.182a5 5 0 0 0-6.723.03z' />
                </clipPath>
                <clipPath id='1ul4ak6nqd'>
                  <path d='M9 0a9 9 0 1 1 0 18A9 9 0 0 1 9 0z' />
                </clipPath>
                <clipPath id='mac961fvye'>
                  <path d='M10.755.264a2.407 2.407 0 0 1 1.492 2.218v1.583c7.705.589 13.677 6.901 13.753 14.539a13.763 13.763 0 0 1-.424 3.368 1.364 1.364 0 0 1-1.232 1.025l-.116.002-.116-.002a1.364 1.364 0 0 1-1.232-1.025c-1.263-4.945-5.538-8.568-10.674-9.048v1.514c0 .969-.589 1.843-1.492 2.218-.979.445-2.13.28-2.942-.419L.847 10.273A2.369 2.369 0 0 1 0 8.46c0-.697.31-1.36.847-1.812L7.772.67a2.763 2.763 0 0 1 2.983-.406z' />
                </clipPath>
              </defs>
              <g clip-path='url(#rkkxw07laa)' transform='translate(-128 -167)'>
                <g clip-path='url(#i2klka0p4b)' transform='rotate(2 -5971.625 4229.062)'>
                  <path
                    d='M9 0h72a9 9 0 0 1 9 9v38a9 9 0 0 1-9 9H9a9 9 0 0 1-9-9V9a9 9 0 0 1 9-9z'
                    stroke='#000'
                    stroke-width='8'
                    fill='none'
                    stroke-miterlimit='5'
                  />
                </g>
                <g clip-path='url(#9dgm2y500c)' transform='rotate(2 -5508.907 4881.826)'>
                  <path d='M0 0h45.001v20.546H0V0z' />
                </g>
                <g clip-path='url(#1ul4ak6nqd)' transform='rotate(2 -5187.816 5288.603)'>
                  <path fill='var(--theme-primary, #810ea9)' d='M0 0h18v18H0V0z' />
                </g>
                <g>
                  <g clip-path='url(#mac961fvye)' transform='rotate(2 -6474.59 5137.201)'>
                    <path fill='var(--theme-primary, #810ea9)' d='M0 0h26v22.999H0V0z' />
                  </g>
                </g>
              </g>
            </svg>

            <h1 style={{textAlign: 'center'}}>המסמך לא הצליח להיטען</h1>
          </div>
        </div>
      ) : (
        <div className='businessAbroadTermsNotFoundPage'>
          <div className='container'>
            <div className='cellcomLogo'>
              <svg width='111' height='40' viewBox='0 0 111 40' xmlns='http://www.w3.org/2000/svg'>
                <g fill='none' fill-rule='evenodd'>
                  <path
                    d='M110.869 4.732c-.16.36-.234.712-.438.956-.464.555-.944 1.116-1.503 1.572-1.616 1.32-3.277 2.586-4.914 3.882-1.328 1.051-2.67 2.092-3.803 3.36a14.518 14.518 0 0 0-1.225 1.584c-.423.63-.435 1.298-.133 2.019.71 1.69 1.586 3.294 2.481 4.889 2.475 4.407 4.871 8.857 7.077 13.405.409.844.688 1.75 1.024 2.63.034.09.053.19.061.287.04.481-.18.758-.649.667-.512-.1-1.04-.258-1.49-.515a63.194 63.194 0 0 1-3.266-2.016c-3.462-2.262-6.911-4.542-10.37-6.81-1.4-.917-2.842-1.765-4.394-2.408-1.18-.488-2.398-.757-3.686-.646-.977.085-1.88.402-2.754.822-1.57.756-2.984 1.761-4.37 2.8-2.775 2.077-5.527 4.184-8.298 6.267-.597.449-1.228.854-1.855 1.261-.246.16-.514.298-.79.396-.427.15-.718-.072-.654-.519.053-.365.164-.729.3-1.073.732-1.845 1.454-3.694 2.229-5.52 1.244-2.931 2.538-5.84 3.788-8.769.447-1.047.828-2.119 1.061-3.243.271-1.306-.094-2.34-1.21-3.07-.624-.408-1.289-.755-1.94-1.12-.464-.26-.94-.5-1.4-.762a6.444 6.444 0 0 1-.74-.487c-.743-.57-.702-1.259.148-1.643a35.666 35.666 0 0 1 2.958-1.174c1.54-.538 3.103-1.014 4.65-1.536.576-.195 1.135-.442 1.702-.668 1.458-.58 2.61-1.555 3.45-2.855.831-1.288 1.559-2.641 2.351-3.954.376-.622.758-1.247 1.213-1.81.26-.322.644-.585 1.025-.76.721-.33 1.239-.182 1.717.449.308.406.564.852.828 1.29.487.808.948 1.633 1.447 2.433a2.835 2.835 0 0 0 1.944 1.33c.538.099 1.103.181 1.641.129 1.723-.169 3.443-.377 5.157-.62 2.687-.38 5.366-.823 8.056-1.193.735-.1 1.495-.06 2.242-.034.303.01.625.111.895.253.181.095.286.335.437.524'
                    fill='var(--theme-primary, #810ea9)'
                  />
                  <path
                    d='M9.599 28.338v-5.7c0-1.31-.582-1.804-1.804-1.804H3.927v7.504h5.672zM0 17.082h7.795c4.188 0 5.73 1.425 5.73 5.73v9.307H0V17.082zM17.221 21.009H15.04v-3.927h6.137v15.037h-3.956zM24.087 36.278h3.956V23.83h-3.956v12.448zm5.759-5.148 3.316-10.122h-9.686v-3.926h14.049v1.774l-3.52 12.914h-4.13l-.03-.64zM42.384 31.508l4.072-10.5h-7.882v-7.213h3.985v3.287h8.696v1.978L46.69 32.12h-4.305zM63.444 24.644c0-2.123-.669-3.635-3.432-3.635H57.57c-.437.988-.756 2.152-.727 3.315 0 2.85 1.425 4.276 3.374 4.276 2.065 0 3.228-1.658 3.228-3.956m-10.325.524c0-1.542.407-2.967.96-4.16h-1.6v-3.926h7.33c5.467 0 7.562 2.589 7.562 7.446 0 4.653-2.85 7.824-7.242 7.824-4.334 0-7.01-2.966-7.01-7.184'
                    fill='#414045'
                  />
                </g>
              </svg>
            </div>
            <svg width='120' height='120' viewBox='0 0 120 120' xmlns='http://www.w3.org/2000/svg'>
              <defs>
                <clipPath id='ehuwplyuba'>
                  <path d='M375 0v667H0V0h375z' />
                </clipPath>
              </defs>
              <g clip-path='url(#ehuwplyuba)' transform='translate(-128 -167)'>
                <path
                  d='M157.71 220.25a30.291 30.291 0 1 1 60.583 0h0c0 15.11 3.16 23.878 5.945 28.67a3.375 3.375 0 0 1-2.903 5.08h-66.67a3.375 3.375 0 0 1-2.903-5.08c2.786-4.793 5.949-13.561 5.949-28.67h0zM174.5 254v3.375c0 7.456 6.044 13.5 13.5 13.5s13.5-6.044 13.5-13.5V254'
                  stroke='#000'
                  stroke-width='3.75'
                  fill='none'
                  stroke-linecap='round'
                  stroke-linejoin='round'
                />
                <path
                  d='M211.386 183.12a44.072 44.072 0 0 1 15.996 17.768m-78.764 0a44.072 44.072 0 0 1 15.996-17.768'
                  stroke='var(--theme-primary, #810ea9)'
                  stroke-width='3.75'
                  fill='none'
                  stroke-linecap='round'
                  stroke-linejoin='round'
                />
              </g>
            </svg>
            <h1 style={{textAlign: 'center'}}>לא מצאנו מסמך עבור חבילה זו</h1>
          </div>
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  cellcomAbroad: state.cellcomAbroad,
  DataPackageData,
  CombinedPackageData,
});

const mapDispatchToProps = {
  fetchPackageBySocCode,
  showAppLoader,
  hideAppLoader,
};
export default connect(mapStateToProps, mapDispatchToProps)(BusinessAbroadTermsMain);
